import $ from 'jquery';
import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import logger from '../../shared/logger';
import './style.scss';
import './services/market-analysis-currency-formatter';
import { INCLUDED, EXCLUDED, CURRENTLY_NOT } from './../../constants/tagAdditionalText';

export class InsightRetortFunnelComponent {
    /* @ngInject */
    constructor(
        $scope,
        $timeout,
        dynamicDataService,
        PositionService,
        $stateParams,
        RouteService,
        DynamicCriteriaWithGroupsService,
        $sce,
        TFTTagsService,
    ) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.PositionService = PositionService;
        this.RouteService = RouteService;
        this.DynamicCriteriaWithGroupsService = DynamicCriteriaWithGroupsService;
        this.dynamicDataService = dynamicDataService;
        this.$sce = $sce;
        this.tftTagsService = TFTTagsService;

        $(window).resize(this.makeFunnelResponsive);
    }

    startLoading() {
        this.$timeout(() => this.loading = true);
    }

    stopLoading() {
        this.$timeout(() => this.loading = false);
    }

    async $onInit() {
        const positionId = this.$stateParams.positionId;
        this.startLoading();

        try {
            this.criteriaFields = await this.getSearchCriteriaFields();
            this.insightBlocks = await this.PositionService.getPositionReports(positionId);

            this.$timeout(() => {
                if (this.insightBlocks) {
                    this.updateCriteriaFields();
                }

                this.$timeout(this.makeFunnelResponsive);
            });
        } catch (error) {
            logger.error(error);
        } finally {
            this.stopLoading();
        }
    }

    updateCriteriaFields() {
        for (let i = 0; i < this.criteriaFields.length; i++) {
            if (this.criteriaFields[i].type === 'minMaxStatic') {
                const minIndex = _.findIndex(this.insightBlocks.desiredCandidateProfile.selected, { field: this.criteriaFields[i].minField });
                const maxIndex = _.findIndex(this.insightBlocks.desiredCandidateProfile.selected, { field: this.criteriaFields[i].maxField });
                if (minIndex >= 0 || maxIndex >= 0) {
                    this.criteriaFields[i].check = true;
                    if (minIndex >= 0) {
                        this.criteriaFields[i].minSelected = this.insightBlocks.desiredCandidateProfile.selected[minIndex].items;
                    }
                    if (maxIndex >= 0) {
                        this.criteriaFields[i].maxSelected = this.insightBlocks.desiredCandidateProfile.selected[maxIndex].items;
                    }
                } else {
                    this.criteriaFields[i].check = false;
                }
            } else {
                const index = _.findIndex(this.insightBlocks.desiredCandidateProfile.selected, { field: this.criteriaFields[i].field });
                if (index >= 0) {
                    this.criteriaFields[i].check = true;
                    this.criteriaFields[i].selected = this.insightBlocks.desiredCandidateProfile.selected[index].items;
                } else {
                    this.criteriaFields[i].check = false;
                }
            }

            if (!_.isNull(this.criteriaFields[i].subCriteria)) {
                this.dynamicDataService.addSubCriteriaData({ criteria: this.criteriaFields[i] });
            }
        }
    }

    async getSearchCriteriaFields() {
        const { RouteService } = this;
        const criteriaFields = RouteService.getSystemPreference('searchCriteriaFields');

        if (!criteriaFields) {
            try {
                await RouteService.init();

                return RouteService.getSystemPreference('searchCriteriaFields') || [];
            } catch (error) {
                logger.error(error);
            }
        }

        return criteriaFields || [];
    }

    makeFunnelResponsive() {
        const funnelImageHeight = $('.employer-report.mobile .funnel-wrapper .insights-funnel-image').height();

        $('.employer-report.mobile .funnel-wrapper').css('height', funnelImageHeight);
    }

    getPriorityStyleConfig(item) {
        const priority = item.required;
        const itemAdditional = item.additional && (item.additional.value || item.additional.text);
        const isExcluded = itemAdditional && [EXCLUDED, CURRENTLY_NOT].includes(itemAdditional);
        return this.tftTagsService.getTagStyles({ priority, isExcluded });
    }

    renderTag(item) {
        const value = _.get(item, 'text', _.get(item, 'value', ''));
        const additional = _.get(item, 'additional.value', '');
        const filteredAdditional = (additional && ![INCLUDED, EXCLUDED, CURRENTLY_NOT].includes(additional)) ?
            `<span style="display: inline-block">, ${additional}</span>` :
            '';

        const { className, styles } = this.getPriorityStyleConfig(item);
        const stylesStr = Object.entries(styles).map(([key, value]) => `${key}: ${value} !important;`).join(' ');

        return this.$sce.trustAsHtml(`
            <div class="tft-tags-list-item__wrapper ${className}"
                style="${stylesStr}">
                ${value}${filteredAdditional}
            </div>`);
    }
}

export const InsightRetortFunnelComponentConfiguration = {
    template,
    controller: InsightRetortFunnelComponent,
    controllerAs: 'reportFunnelCtrl',
};

angular
    .module('TALENYA-FE')
    .component('reportFunnelComponent', InsightRetortFunnelComponentConfiguration);

